import { DOCUMENT } from "@angular/common";
import { ChangeDetectionStrategy, Component, Inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { catchError, of, switchMap } from "rxjs";
import { OrganizationSwitchService } from "../../features/organization-switch/organization-switch.service";

@Component({
  selector: "new-ui-org-switch",
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewUiOrgSwitchComponent implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly organizationSwitchService: OrganizationSwitchService,
    private readonly authService: AuthService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  ngOnInit(): void {
    this.organizationSwitchService
      .switch(this.route.snapshot.params.orgId)
      .pipe(
        // After the backend has updated the user's metadata in Auth0
        // (new organizationId), force a cache-bypassing token refresh so that
        // the localStorage cache is updated with a fresh JWT for the new org
        // *before* the hard reload.  Without this, the reload would serve the
        // stale cached token and the backend would see the wrong org context,
        // returning null userPermissions and triggering a redirect loop.
        switchMap(() => this.authService.getAccessTokenSilently({ cacheMode: "off" }).pipe(catchError(() => of(null))))
      )
      .subscribe(() => {
        this.document.defaultView.location.href = this.route.snapshot.params.href ?? "/";
      });
  }
}
